import { useEffect, useRef } from "react";

const useCheckoutCotizacionToast = ({ cotizacionId, toastRef }) => {
  const prevCotizacionIdRef = useRef(null);

  useEffect(() => {
    const prevId = prevCotizacionIdRef.current;
    prevCotizacionIdRef.current = cotizacionId;
    if (prevId && cotizacionId && prevId !== cotizacionId) {
      toastRef.current?.show({
        severity: "info",
        summary: "Cotización",
        detail: `Cotización N° ${cotizacionId} activa.`,
        life: 3500,
      });
    }
  }, [cotizacionId, toastRef]);
};

export default useCheckoutCotizacionToast;